import CaretUpOutline from './CaretUpOutline'

export default CaretUpOutline
// eslint-disable-next-line import/export
export * from './CaretUpOutline'
